var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBusMode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bx:bus"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M21.504 8.475V6.5C21.504 4.294 19.71 2.5 17.504 2.5H7.504C5.298 2.5 3.504 4.294 3.504 6.5V8.498L3.428 8.502C3.1758 8.52021 2.93986 8.63328 2.76768 8.81845C2.59549 9.00362 2.49985 9.24714 2.5 9.5V11.5C2.5 11.7652 2.60536 12.0196 2.79289 12.2071C2.98043 12.3946 3.23478 12.5 3.5 12.5H3.504V18.5C3.504 19.235 3.907 19.872 4.5 20.22V21.5C4.5 21.7652 4.60536 22.0196 4.79289 22.2071C4.98043 22.3946 5.23478 22.5 5.5 22.5H6.5C6.76522 22.5 7.01957 22.3946 7.20711 22.2071C7.39464 22.0196 7.5 21.7652 7.5 21.5V20.5H17.5V21.5C17.5 21.7652 17.6054 22.0196 17.7929 22.2071C17.9804 22.3946 18.2348 22.5 18.5 22.5H19.5C19.7652 22.5 20.0196 22.3946 20.2071 22.2071C20.3946 22.0196 20.5 21.7652 20.5 21.5V20.224C20.804 20.0501 21.0569 19.7992 21.2331 19.4966C21.4094 19.1939 21.5028 18.8502 21.504 18.5V12.5C21.7692 12.5 22.0236 12.3946 22.2111 12.2071C22.3986 12.0196 22.504 11.7652 22.504 11.5V9.562C22.5155 9.40681 22.4909 9.25106 22.432 9.107C22.229 8.62 21.797 8.503 21.504 8.475ZM19.506 18.5H5.504V13.5H19.505L19.506 18.5ZM11.504 7.5V11.5H5.504V7.5H11.504ZM19.504 7.5V11.5H13.504V7.5H19.504ZM7.504 4.5H17.504C18.24 4.5 18.879 4.905 19.226 5.5H5.782C6.129 4.905 6.768 4.5 7.504 4.5Z",
    fill: "#4F4F4F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M8 17.5C8.82843 17.5 9.5 16.8284 9.5 16C9.5 15.1716 8.82843 14.5 8 14.5C7.17157 14.5 6.5 15.1716 6.5 16C6.5 16.8284 7.17157 17.5 8 17.5Z",
    fill: "#4F4F4F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M17 17.5C17.8284 17.5 18.5 16.8284 18.5 16C18.5 15.1716 17.8284 14.5 17 14.5C16.1716 14.5 15.5 15.1716 15.5 16C15.5 16.8284 16.1716 17.5 17 17.5Z",
    fill: "#4F4F4F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusMode);
export default __webpack_public_path__ + "static/media/busMode.c21f5ed183f3fa2ddbffb689f0ef6575.svg";
export { ForwardRef as ReactComponent };